import { gql } from '@apollo/client';

import client from '../../../../../core/services/graphql';
import { GET_RECRUITING_LINKS } from '../../graphql';

export const createLink = async (projectId, segmentId, capResponses, demographicsFormRequired, isDisqualifyQuestionOptionsRequired) => {
  const mutation = gql`
    mutation createLink(
      $projectId: ID!,
      $segmentId: ID!,
      $capResponses: Int,
      $demographicsFormRequired: Boolean,
      $isDisqualifyQuestionOptionsRequired: Boolean
    ) {
      createRecruitingLink(
        projectId: $projectId, 
        segmentId: $segmentId, 
        capResponses: $capResponses, 
        demographicsFormRequired: $demographicsFormRequired,
        isDisqualifyQuestionOptionsRequired: $isDisqualifyQuestionOptionsRequired,
        ) {
        link
      }
    }
  `;

  return client.getClient().mutate({
    mutation,
    variables: {
      projectId, segmentId, capResponses, demographicsFormRequired, isDisqualifyQuestionOptionsRequired,
    },
  });
};

export const fetchRecruitingLinks = async (projectId) => (
  client.query({
    query: GET_RECRUITING_LINKS,
    variables: {
      projectId,
    },
  })
);
